import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  DatePicker,
  Select,
  Typography,
  Space,
  Tag,
  Drawer,
  Divider,
  Button,
  Form,
  List,
  Avatar,
  Image,
  Alert,
  Row,
  Col,
  Upload,
  message,
  Statistic,
  Card,
  Tooltip,
  Popconfirm,
} from "antd";

import TextArea from "antd/es/input/TextArea";

import dayjs from "dayjs";
import axios from "axios";
import constants from "../constants";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";

import { useAuth } from "../contexts/authContext";
import Meta from "antd/es/card/Meta";

function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}

const tailLayout = {
  wrapperCol: { offset: 0, span: 24 },
};

const ProcessComission = () => {
  const { Option } = Select;
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [drawerData, setDrawerData] = useState(false);

  const [form] = Form.useForm();

  const { getToken } = useAuth();

  const fetchLeadsFromServer = async (query) => {
    try {
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };

      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartner/getPartnerCommissionDetails`;
      const res = await axios.get(url, {
        headers,
      });

      return {
        data: res.data?.data,
      };
    } catch (error) {
      throw new Error(error?.message || "something went wrong , try again later");
    }
  };

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");

    fetchLeadsFromServer()
      .then((res) => {
        if (cancelled) return;
        setRows(res.data);
        setTotal(res.total);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.message || "Failed to load leads");
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const updateDetails = async (data) => {
    console.log(data);
    const url = `${constants.NEW_DOMAIN}/api/v1/channelPartner/processPartnerCommission/${data._id}`;

    setLoading(true);

    try {
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };

      const res = await axios.post(
        url,
        {
          amount: data.commisionPending,
        },
        { headers }
      );
      setRows((prev) => {
        const updatedRows = prev.filter((d) => {
          if (d._id === data._id) {
            return false;
          }
          return true;
        });
        return updatedRows;
      });
      setLoading(false);
      setDrawerData(false);
      message.success("Data updated successfully");
    } catch (error) {
      setLoading(false);
      setError(error.message || "something went wrong , try again later");
    }
  };

  const columns = [
    {
      title: (
        <Space direction="vertical" size={4}>
          <span>Name</span>
        </Space>
      ),
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    {
      title: (
        <Space direction="vertical" size={4}>
          <span>Phone</span>
        </Space>
      ),
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: <span>Commision Amount</span>,
      dataIndex: "commisionPending",
      key: "commision",
      render: (data) => <Tag color="blue">INR {data}</Tag>,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <a
          onClick={() => {
            console.log(record);
            // form.setFieldsValue({ ...record, followupDate: record.followupDate ? dayjs(record.followupDate) : null, id: record._id });
            setDrawerData(record);
          }}
        >
          Process <EditOutlined />
        </a>
      ),
    },
  ];

  return (
    <div style={{ padding: "12px" }}>
      <Typography.Title level={3} style={{ margin: "8px 0 16px" }} mark>
        Process Commision
      </Typography.Title>

      {error ? <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable /> : null}

      <Drawer
        title="Process Commision"
        closable={{ "aria-label": "Close Button" }}
        size="large"
        onClose={() => {
          setDrawerData(false);
          form.resetFields();
        }}
        open={drawerData}
      >
        <Statistic
          style={{ marginBottom: "20px" }}
          title="Total Commision Earned"
          value={drawerData.totalCommisionEarned}
          precision={2}
          valueStyle={{ color: "green" }}
          suffix="₹"
        />
        <Divider />

        <Typography.Text level={4} style={{ marginBottom: "20px" }}>
          If you mark as paid, the commision will be added to {drawerData.name}'s account and the pending commision will be set to 0.
        </Typography.Text>

        {error ? <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable /> : null}

        <Row gutter={16} style={{ marginTop: "20px" }}>
          <Col span={12}>
            <Card
              variant="borderless"
              actions={[
                <Popconfirm
                  title="Process Commision"
                  description="Are you sure to process this commision?"
                  onConfirm={() => updateDetails(drawerData)}
                  onCancel={() => {
                    //
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button>Mark as Paid</Button>
                </Popconfirm>,
              ]}
            >
              <Statistic title="Pending Commision" value={drawerData.commisionPending} precision={2} valueStyle={{ color: "blue" }} suffix="₹" />
            </Card>
          </Col>
        </Row>
      </Drawer>
      <Table tableLayout="fixed" rowKey="_id" size="small" loading={loading} dataSource={rows} columns={columns} scroll={{ x: true }} />
    </div>
  );
};

export default ProcessComission;
